import { render } from "./Club.vue?vue&type=template&id=abf4aa52&scoped=true"
import script from "./Club.vue?vue&type=script&lang=ts"
export * from "./Club.vue?vue&type=script&lang=ts"

import "./Club.vue?vue&type=style&index=0&id=abf4aa52&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-abf4aa52"

export default script